/**
 * The message to show a user when a jQuery `$.ajax` call fails.
 *
 * When the server refuses a request deliberately — a rate limit, a validation
 * failure — it answers with a JSON `errorMessage` written for the user, and
 * that is what they need to read. Anything else (a dropped connection, a 500)
 * has nothing worth showing, so a generic apology stands in — pass `fallback`
 * where the caller has more specific wording for that case.
 *
 * `responseJSON` only exists in jQuery 1.9+, and the landing page still loads
 * 1.8.3, hence the parse of `responseText`.
 *
 * No imports: this is used by the landing page bundle, which deliberately
 * pulls in as little as possible.
 */
export const ajaxErrorMessage = (
  jqXHR: { responseJSON?: unknown; responseText?: string } | undefined,
  fallback = "Sorry, something went wrong. Please try again."
): string => {
  let body = jqXHR?.responseJSON;
  if (body === undefined && jqXHR?.responseText) {
    try {
      body = JSON.parse(jqXHR.responseText);
    } catch {
      return fallback;
    }
  }
  const errorMessage = (body as { errorMessage?: unknown })?.errorMessage;
  return typeof errorMessage === "string" && errorMessage
    ? errorMessage
    : fallback;
};
